/**
 * The side menu's "needs your answer" badge counts questioned products. It is
 * outside the page that answers them, so the page says when the count moved.
 */
const EVENT = 'glp-vendor-products-changed';

export function notifyProductsChanged(): void {
  window.dispatchEvent(new Event(EVENT));
}

export function onProductsChanged(listener: () => void): () => void {
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
